module.exports = __webpack_public_path__ + "assets/img/touxiang_s.8f165103.png";